// 取得語系代碼
function getLanguageCode(locale) {
  // 語系代碼格式: en-US, zh-CN, es-MX 等
  // 提取語言代碼（破折號前的第一部分）
  const langCode = locale?.split('-')?.[0]?.toLowerCase()
  // 特殊映射 (因破折號前的第一部分無法區分某些語系)
  if (locale === 'es-MX') return 'mx'
  return langCode || 'en'
}

export { getLanguageCode }
